import { Controller } from '@hotwired/stimulus';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
    static targets = ['content', 'image', 'sidebarWrapper', 'contentInner'];

    connect() {
        this.ctx = gsap.context(() => {

            // Animation for the image (scale down on scroll)
            gsap.set(this.imageTarget, {
                scale: 1.4,
            });

            gsap.to(this.imageTarget, {
                scale: 1,
                ease: 'none',
                scrollTrigger: {
                    trigger: this.element,
                    start: 'top bottom',
                    end: 'bottom bottom',
                    scrub: true,
                },
            });

            // Pinning & Sidebar Slide-In
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.element,
                    start: 'bottom bottom',
                    end: '+=600',
                    pin: this.sidebarWrapperTarget,
                    scrub: 1.5,
                }
            });

            // Sidebar container slide in
            gsap.set(this.contentTarget, {
                xPercent: 100,
                opacity: 1,
            });

            // Sidebar content
            gsap.set(this.contentInnerTarget, {
                yPercent: 90, // 50% der eigenen Höhe nach unten verschoben
            });

            // Sidebar container initial state
            tl.to(this.contentTarget, {
                xPercent: 0,
                ease: 'power1.out',
            }, 0);

            // Image slide to the left
            tl.to(this.imageTarget, {
                xPercent: -20,
                ease: 'power1.out',
            }, 0);

            // Sidebar content slide up
            tl.to(this.contentInnerTarget, {
                yPercent: 0, // Zurück zur ursprünglichen Y-Position
                ease: 'power2.out',
            }, '<0.1');

        }, this.element);
    }

    disconnect() {
        console.log('Hero Slide-In controller disconnected! Cleaning up animations.');
        this.ctx.revert();
    }
}
